import Select from 'react-select';
import React, { useState, useEffect } from 'react'
import ToastNotification from '../../../components/ToastNotification';
import axios from 'axios'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { MdLocalPrintshop } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import html2canvas from "html2canvas";
import { useLoading } from '../../../context/LoadingContext';
import { toWords } from "number-to-words";

function AccountDocument({ adminData, companyID, branchID }) {


    const { setLoading } = useLoading();
    const [noteType, setNoteType] = useState(null);
    const [fetchData, setfetchData] = useState([]);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [branchDetail, setBranchDetail] = useState([])
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [selectedQuotation, setSelectedQuotation] = useState(null);
    const [company, setCompany] = useState([]);
    const [showPDFModal, setShowPDFModal] = useState(false);



    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };


    const reportOptions = [
        { value: 'credit_note', label: 'Credit Note' },
        { value: 'debit_note', label: 'Debit Note' },
        { value: 'bank_payment', label: 'Bank Payment' },
        { value: 'cash_payment', label: 'Cash Payment' },
        { value: 'bank_receipt', label: 'Bank Receipt' },
        { value: 'cash_receipt', label: 'Cash Receipt' },
    ]


    const numberToWords = (amount) => {
        if (!amount) return "";

        const num = Number(amount);
        if (isNaN(num)) return "";

        const words = toWords(num);

        return words
            .replace(/-/g, " ")
            .split(" ")
            .filter(Boolean)
            .map(word =>
                word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join(" ");
    };

    const fetchBranchDetail = async () => {
        setLoading(true)
        try {
            const resInventory = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(resInventory.data)

        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };




    const fetchCompany = async () => {
        setLoading(true)
        try {
            const res = await axios.get(`https://api.skyguard.group/api/fetch-company-localData/${companyID}`);
            setCompany(res.data);

        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {

        fetchBranchDetail();
        fetchCompany();
    }, []);



    const handleSearch = async (e) => {
        e.preventDefault();

        try {
            const params = {
                note_type: noteType?.value,
                from_date: fromDate,
                to_date: toDate
            };


            const result = await axios.get(
                'https://api.skyguard.group/api/get-account-document',
                { params }
            );

            const resultData = result?.data?.result || [];
        

            setfetchData(resultData);

            if (resultData.length > 0) {
                setToast('Report fetched successfully', 'success');
            } else {
                setToast('No data found in selected date range', 'warning');
            }

        } catch (error) {
            console.error('❌ Error fetching report:', error);
            setToast('Error fetching report. Please try again.', 'danger');
        }
    };


    const formatDateTime = (datetime) => {
        if (!datetime) return "";
        const [date, time] = datetime.split(" ");
        const [year, month, day] = date.split("-");
        return `${day}-${month}-${year} ${time}`;
    };

    const handleExportExcel = () => {
        const table = document.getElementById("exportTable");

        if (!table) return;

        const worksheet = XLSX.utils.table_to_sheet(table);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const data = new Blob([excelBuffer], {
            type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });

        saveAs(data, "Sale_Report.xlsx");
    };



    const handlePrint = () => {
        const printContents = document.getElementById("invoice-print-area").innerHTML;
        const originalContents = document.body.innerHTML;

        // Open a new window for printing
        const printWindow = window.open("", "_blank", "width=900,height=600");
        printWindow.document.write(`
    <html>
      <head>
     
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          table { border-collapse: collapse; width: 100%; }
          table, th, td { border: 1px solid #000; }
          th, td { padding: 5px; text-align: center; }
          .text-start { text-align: left; }
        </style>
      </head>
      <body>
        ${printContents}
      </body>
    </html>
  `);

        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };




    const handleSaveMergedPDF = async () => {

        const pdf = new jsPDF("p", "mm", "a4");

        const pages = document.querySelectorAll(".pdf-page");

        for (let i = 0; i < pages.length; i++) {

            const canvas = await html2canvas(pages[i], {
                scale: 2,
                useCORS: true,
            });

            const imgData = canvas.toDataURL("image/png");

            const imgWidth = 210;

            const imgHeight =
                (canvas.height * imgWidth) / canvas.width;

            if (i > 0) {
                pdf.addPage();
            }

            pdf.addImage(
                imgData,
                "PNG",
                0,
                0,
                imgWidth,
                imgHeight
            );
        }

        pdf.save("All_AMC_Bills.pdf");
    };

    const isServiceCard = noteType?.value === "service_card";

    const th = {
        border: "1px solid #000",
        padding: "5px",
        fontSize: "12px",
        background: "#f2f2f2",
    };

    const td = {
        border: "1px solid #000",
        padding: "5px",
        fontSize: "12px",
    };


    const isCreditDebit =
  noteType?.value === "credit_note" ||
  noteType?.value === "debit_note";

    return (
        <div className='main-section'>
            <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast({ ...toast, show: false })}
            />
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>

                <h3 className='my-3 fw-bold fs-5 golos'>Account Documents</h3>


                <div className="row g-3 align-items-end">
                    <div className="col-md-4">
                        <label className='fw-bold'>Select Document</label>
                        <Select
                            options={reportOptions}
                            placeholder="Choose Type ..."
                            id="source"
                            value={noteType}

                            onChange={(selected) => {
                                setNoteType(selected);
                                setfetchData([]);
                            }}
                        />
                    </div>

                    <div className="col-md-4">
                        <label className='fw-bold'>From Date</label>
                        <input
                            type="date"
                            className="form-control"
                            name="from_date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                        />
                    </div>

                    <div className="col-md-4">
                        <label className='fw-bold'>To Date</label>
                        <input
                            type="date"
                            className="form-control"
                            name="to_date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                        />
                    </div>


                    <div className="col-md-12 d-flex justify-content-end align-items-end">
                        {/* <button className="btn btn-primary" onClick={handleSearch} >Search</button> */}
                        <FaSearch size={26} className="ms-1 text-primary"
                            style={{ cursor: "pointer" }}
                            title="Search"
                            onClick={handleSearch}
                        />

                        <MdLocalPrintshop
                            size={26}
                            className="ms-1 text-success me-1"
                            onClick={handleExportExcel}
                            style={{ cursor: "pointer" }}
                            title="Print "
                        />

                        <button
                            className='btn btn-warning'
                            onClick={() => setShowPDFModal(true)}
                        >
                            Download PDF
                        </button>
                    </div>
                </div>

                <div id="exportTable" className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                    {noteType?.value === 'bank_payment' && (
                        <table className='table table-bordered table-striped table-hover text-center align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>Doc No</th>
                                    <th>Date</th>
                                    <th>Account</th>
                                    <th>Remark</th>

                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(fetchData) && fetchData.length > 0 ? (
                                    fetchData.map((item, idx) => {

                                        let items = [];
                                        try {
                                            items = JSON.parse(item.items || "[]");
                                        } catch (e) {
                                            items = [];
                                        }

                                        return (
                                            <tr key={idx}>

                                                {/* Doc No */}
                                                <td>{`BP/${item.inv_no}/${item.branchId}`}</td>

                                                <td>{item.quotation_date}</td>
                                                <td>{item.main_account}</td>
                                                     <td>{item.remark}</td>

                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="9">No data found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}

                       {noteType?.value === 'cash_payment' && (
                        <table className='table table-bordered table-striped table-hover text-center align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>Doc No</th>
                                    <th>Date</th>
                                    <th>Account</th>
                                    <th>Remark</th>

                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(fetchData) && fetchData.length > 0 ? (
                                    fetchData.map((item, idx) => {

                                        let items = [];
                                        try {
                                            items = JSON.parse(item.items || "[]");
                                        } catch (e) {
                                            items = [];
                                        }

                                        return (
                                            <tr key={idx}>

                                                {/* Doc No */}
                                                <td>{`CP/${item.inv_no}/${item.branchId}`}</td>

                                                <td>{item.quotation_date}</td>
                                                <td>{item.main_account}</td>
                                                     <td>{item.remark}</td>

                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="9">No data found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}

                       {noteType?.value === 'bank_receipt' && (
                        <table className='table table-bordered table-striped table-hover text-center align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>Doc No</th>
                                    <th>Date</th>
                                    <th>Account</th>
                                    <th>Remark</th>

                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(fetchData) && fetchData.length > 0 ? (
                                    fetchData.map((item, idx) => {

                                        let items = [];
                                        try {
                                            items = JSON.parse(item.items || "[]");
                                        } catch (e) {
                                            items = [];
                                        }

                                        return (
                                            <tr key={idx}>

                                                {/* Doc No */}
                                                <td>{`BR/${item.inv_no}/${item.branchId}`}</td>

                                                <td>{item.quotation_date}</td>
                                                <td>{item.main_account}</td>
                                                     <td>{item.remark}</td>

                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="9">No data found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}

                       {noteType?.value === 'cash_receipt' && (
                        <table className='table table-bordered table-striped table-hover text-center align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>Doc No</th>
                                    <th>Date</th>
                                    <th>Account</th>
                                    <th>Remark</th>

                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(fetchData) && fetchData.length > 0 ? (
                                    fetchData.map((item, idx) => {

                                        let items = [];
                                        try {
                                            items = JSON.parse(item.items || "[]");
                                        } catch (e) {
                                            items = [];
                                        }

                                        return (
                                            <tr key={idx}>

                                                {/* Doc No */}
                                                <td>{`CR/${item.inv_no}/${item.branchId}`}</td>

                                                <td>{item.quotation_date}</td>
                                                <td>{item.main_account}</td>
                                               <td>{item.remark}</td>

                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="9">No data found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}


                      {noteType?.value === 'credit_note' && (
                        <table className='table table-bordered table-striped table-hover text-center align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>Doc No</th>
                                    <th>Date</th>
                                    <th>Account</th>
                                    <th>Party</th>

                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(fetchData) && fetchData.length > 0 ? (
                                    fetchData.map((item, idx) => {

                                        let items = [];
                                        try {
                                            items = JSON.parse(item.items || "[]");
                                        } catch (e) {
                                            items = [];
                                        }

                                        return (
                                            <tr key={idx}>

                                                {/* Doc No */}
                                                <td>{`CN/${item.inv_no}/${item.branchId}`}</td>

                                                <td>{item.quotation_date}</td>
                                                <td>{item.main_account}</td>
                                                <td>
  {item.tableRowParsed?.map((row, i) => (
    <div key={i}>
      <div>{row.party_detail?.name || "-"}</div>
      <div>{row.party_detail?.mobile || "-"}</div>
    </div>
  ))}
</td>

                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="9">No data found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}

                      {noteType?.value === 'debit_note' && (
                        <table className='table table-bordered table-striped table-hover text-center align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>Doc No</th>
                                    <th>Date</th>
                                    <th>Account</th>
                                    <th>Party</th>

                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(fetchData) && fetchData.length > 0 ? (
                                    fetchData.map((item, idx) => {

                                        let items = [];
                                        try {
                                            items = JSON.parse(item.items || "[]");
                                        } catch (e) {
                                            items = [];
                                        }

                                        return (
                                            <tr key={idx}>

                                                {/* Doc No */}
                                                <td>{`DN/${item.inv_no}/${item.branchId}`}</td>

                                                <td>{item.quotation_date}</td>
                                                <td>{item.main_account}</td>
                                                <td>
  {item.tableRowParsed?.map((row, i) => (
    <div key={i}>
      <div>{row.party_detail?.name || "-"}</div>
      <div>{row.party_detail?.mobile || "-"}</div>
    </div>
  ))}
</td>

                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="9">No data found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}

                

                </div>




                {showPDFModal && (
                    <div
                        className="position-fixed top-0 start-0 w-100 h-100"
                        style={{
                            background: "rgba(0,0,0,0.6)",
                            zIndex: 9999,
                            overflowY: "auto",
                            padding: "20px",
                        }}
                    >


                        <div
                            style={{
                                width: "210mm",
                                margin: "0 auto",
                            }}
                        >


                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    background: "#fff",
                                    padding: "12px 20px",
                                    borderRadius: "8px",
                                    marginBottom: "10px",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                }}
                            >


                                <h3
                                    style={{
                                        margin: 0,
                                        fontWeight: "700",
                                        color: "#222",
                                    }}
                                >
                                    Preview All Bills
                                </h3>

                                <div
                                    style={{
                                        display: "flex",
                                        gap: "10px",
                                    }}
                                >

                                    <button
                                        className="btn btn-success"
                                        onClick={handleSaveMergedPDF}
                                    >
                                        Save PDF
                                    </button>

                                    <button
                                        className="btn btn-danger"
                                        onClick={() => setShowPDFModal(false)}
                                    >
                                        Close
                                    </button>

                                </div>

                            </div>

                        </div>

                        <div id="all-bills-pdf">

                            {fetchData.map((quotation, index) => {


                                let parsedItems = [];

                                try {
                                    parsedItems = JSON.parse(quotation.items || "[]");
                                } catch {
                                    parsedItems = [];
                                }

                                let parsedAdditionalDetails = [];

                                try {
                                    parsedAdditionalDetails = JSON.parse(
                                        quotation.additional_charges || "[]"
                                    );
                                } catch {
                                    parsedAdditionalDetails = [];
                                }

                                 const party =
    quotation.tableRowParsed?.[0]?.party_detail || {};

                                const headerImageUrl =
                                    `https://api.skyguard.group/uploads/${branchDetail.header_img}`;

                                return (

                                    <>

                                        {isCreditDebit ? (
 <div
    className="pdf-page"
    style={{
      width: "210mm",
      minHeight: "297mm",
      margin: "10px auto",
      background: "#fff",
      padding: "12mm",
      fontFamily: "Arial",
      fontSize: "13px",
      color: "#000",
    }}
  >

    {/* HEADER */}
    <div style={{ textAlign: "center", borderBottom: "2px solid #000", paddingBottom: "8px" }}>
      <h2 style={{ margin: 0 }}>{company.name}</h2>
      <h3 style={{ margin: "5px 0", color: "red" }}>
        {noteType?.value === "credit_note" ? "CREDIT NOTE" : "DEBIT NOTE"}
      </h3>
    </div>

    {/* INFO */}
    <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
      <div>
        <b>Voucher No:</b>{" "}
        {noteType?.value === "credit_note" ? "CN" : "DN"}
        /{quotation.inv_no}/{quotation.branchId}
      </div>

      <div>
        <b>Date:</b> {quotation.quotation_date}
      </div>
    </div>

    {/* PARTY BOX (FIXED) */}
    <div style={{ border: "1px solid #000", padding: "10px", marginTop: "15px" }}>
      <b>To,</b>

      <div style={{ marginTop: "5px" }}>
        <b>{party.name || quotation.party_name || "-"}</b>
      </div>

      <div>
        {party.address || quotation.party_address || "-"}
      </div>

      <div>
        <b>Mobile:</b>{" "}
        {party.mobile || quotation.party_mobile || "-"}
      </div>
    </div>

    {/* MESSAGE */}
    <div style={{ marginTop: "20px", lineHeight: "1.8" }}>
      <p>
        This is to inform you that your account has been{" "}
        <b>
          {noteType?.value === "credit_note" ? "credited" : "debited"}
        </b>{" "}
        with Rs. <b>{quotation.amount || "0.00"}</b>
      </p>
    </div>

    {/* SIGNATURE */}
    <div style={{ marginTop: "60px" }}>
      <div>Regards,</div>
      <br />
      <div>For</div>
      <br />
      <b>{company.name}</b>
    </div>

  </div>
                                        ) : (

                                            <div
                                                key={index}
                                                className="pdf-page"
                                                style={{
                                                    width: "210mm",
                                                    minHeight: "297mm",
                                                    margin: "10px auto",
                                                    background: "#fff",
                                                    padding: "10mm",
                                                    boxSizing: "border-box",
                                                    pageBreakAfter: "always",
                                                    position: "relative",
                                                }}
                                            >


                                                <img
                                                    src={headerImageUrl}
                                                    alt="watermark"
                                                    style={{
                                                        position: "absolute",
                                                        top: "35%",
                                                        left: "50%",
                                                        width: "300px",
                                                        opacity: "0.1",
                                                        transform: "translate(-50%, -50%)",
                                                        zIndex: 0,
                                                    }}
                                                />

                                                <div style={{ position: "relative", zIndex: 1 }}>


                                                    <h3
                                                        style={{
                                                            textAlign: "center",
                                                            marginBottom: "10px",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {noteType?.value === "amc_invoice" && "AMC Invoice"}
                                                        {noteType?.value === "amc_quotation" && "AMC Quotation"}
                                                        {noteType?.value === "service_card" && "Service Card"}

                                                    </h3>




                                                    <table className="invoice-table">
                                                        <tbody>
                                                            <tr>

                                                                <td style={{ width: "60%" }}>
                                                                    <strong>{company.name}</strong><br />

                                                                    {company.address}<br />

                                                                    Phone: {company.phone}<br />

                                                                    GSTIN: {company.gst}<br />

                                                                    Email: {company.email}<br />

                                                                    PAN: {company.pan}
                                                                </td>

                                                                <td style={{ width: "40%" }}>

                                                                    <table className="invoice-table">

                                                                        <tbody>

                                                                            <tr>
                                                                                <td>Date</td>
                                                                                <td>{quotation.quotation_date}</td>
                                                                            </tr>

                                                                            <tr>
                                                                                <td>Ref Doc</td>


                                                                                <td>
                                                                                    {noteType?.value === "bank_payment"
                                                                                        ? "BP"
                                                                                        : noteType?.value === "cash_payment"
                                                                                            ? "CP"
                                                                                            : noteType?.value === "bank_receipt"
                                                                                                ? "BR"
                                                                                                : noteType?.value === "cash_receipt"
                                                                                                    ? "CR"
                                                                                                    : noteType?.value === "credit_note"
                                                                                                        ? "CN"
                                                                                                        : noteType?.value === "debit_note"
                                                                                                            ? "DN"
                                                                                                            : ""}
                                                                                    /{quotation.inv_no}/{quotation.branchId}
                                                                                </td>
                                                                            </tr>

                                                                        </tbody>

                                                                    </table>

                                                                </td>

                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <table
  className="invoice-table"
  style={{ marginTop: "10px" }}
>
  <tbody>
    <tr>
      <td style={{ width: "25%" }}>
        <strong>Main Account</strong>
      </td>

      <td style={{ width: "25%" }}>
        {quotation.main_account}
      </td>

      <td style={{ width: "25%" }}>
        <strong>Cheque No</strong>
      </td>

      <td style={{ width: "25%" }}>
        {quotation.cheque_no || "-"}
      </td>
    </tr>

    <tr>
      <td>
        <strong>Cheque Date</strong>
      </td>

      <td>
        {quotation.cheque_date || "-"}
      </td>

      <td>
        <strong>Remark</strong>
      </td>

      <td>
        {quotation.remark || "-"}
      </td>
    </tr>
  </tbody>
</table>



{/* 
                                                    <table
                                                        className="invoice-table"
                                                        style={{ marginTop: "5px" }}
                                                    >

                                                        <thead>

                                                            <tr>
                                                                <th>Sr No</th>
                                                                <th>Account Name</th>

                                                            </tr>

                                                        </thead>

                                                        <tbody>

                                                            {parsedItems.map((item, i) => (

                                                                <tr key={i}>
                                                                    <td>{i + 1}</td>
                                                                    <td>{item.name}</td>
                                                                    <td>{item.qty}</td>

                                                                </tr>

                                                            ))}

                                                        </tbody>

                                                    </table> */}

                                                </div>
                                            </div>
                                        )}
                                    </>



                                );
                            })}
                        </div>

                        {/* CSS */}
                        <style>
                            {`
        .invoice-table {
          width: 100%;
          border-collapse: collapse;
        }
  
        .invoice-table td,
        .invoice-table th {
          border: 1px solid #000;
          padding: 5px;
          font-size: 12px;
        }
  
        @media print {
          .pdf-page {
            margin: 0;
            box-shadow: none;
          }
        }
        `}
                        </style>

                    </div>
                )}


            </div>
        </div>
    )
}

export default AccountDocument